import { flattenCategories } from "@fry-it/risr-core";


export interface RelationApiCategory {
    _id: string;
    name: string;
    description: string;
    categories: RelationApiCategory[];
}

export interface RelationApiResponse {
    _id: string;
    _rev: string;
    categories?: RelationApiCategory[];
    name: string;
    description: string;
    organisation: string;
    modifiedDate: string;
    systemModifiedDate: string;
}

export interface RelationCategory {
    _id: string;
    name: string;
    description: string;
    categories: RelationCategory[];
}

export class Relation {
    id: string;
    rev: string;
    categories?: RelationCategory[];
    name: string;
    description: string;
    organisation: string;
    modifiedDate: string;
    systemModifiedDate: string;

    private constructor(data: Partial<Relation> = {}) {
        Object.assign(this, data);
    }

    static fromApiResponse(response: RelationApiResponse): Relation {
        return new Relation({
            id: response._id,
            rev: response._rev,
            categories: response.categories,
            name: response.name,
            description: response.description,
            organisation: response.organisation,
            modifiedDate: response.modifiedDate,
            systemModifiedDate: response.systemModifiedDate
        });
    }

    flatCategories(): RelationCategory[] {
        if (this.categories === undefined) {
            return [];
        }
        return flattenCategories(this.categories);
    }

}
